module.exports = __webpack_public_path__ + "img/05-02_Being Technically Competent.55eefaa2.svg";